import PostalStamp from '../PostalStamp';

/**
 * Abeto de Navidad dentro del marco de PostalStamp — el matasellos de
 * diciembre. Mismo vocabulario que PumpkinIcon, FireworksIcon y
 * SummerSunIcon (trazo lineal, un solo marco postal), para que las
 * temporadas se lean como una colección.
 *
 * Los textos curvos ocupan el borde del sello (y < 24 arriba, y > 92 abajo),
 * así que el árbol vive entre y=29 y y=87. El texto de arriba mide 19
 * caracteres, igual que el de PumpkinIcon: con 21 ("TEMPORADA · DICIEMBRE")
 * se salía del arco y se recortaba en ambos extremos.
 */
export default function ChristmasIcon({ className = '' }) {
    const line = { stroke: 'var(--oro-fiesta)', strokeWidth: 1.8, strokeLinejoin: 'round' };
    return (
        <PostalStamp topText="FIESTAS · DICIEMBRE" bottomText="NAVIDAD" className={className} color="var(--oro-fiesta)">
            {/* Estrella de la punta */}
            <path
                d="M60 27 L62.2 32.2 L67.8 32.6 L63.5 36.2 L64.9 41.6 L60 38.7 L55.1 41.6 L56.5 36.2 L52.2 32.6 L57.8 32.2 Z"
                fill="var(--oro-fiesta)"
            />
            {/* Tres pisos del árbol, de arriba abajo para que cada uno tape el borde del anterior */}
            <path d="M60 40 L50 56 L70 56 Z" fill="var(--salvia)" fillOpacity="0.28" {...line} />
            <path d="M60 48 L46 68 L74 68 Z" fill="var(--salvia)" fillOpacity="0.28" {...line} />
            <path d="M60 58 L42 82 L78 82 Z" fill="var(--salvia)" fillOpacity="0.28" {...line} />
            {/* Tronco */}
            <rect x="56" y="82" width="8" height="6" fill="var(--oro-fiesta)" fillOpacity="0.55" />
            {/* Esferas: rojo nochebuena y oro, repartidas como si las hubieran colgado a mano */}
            <circle cx="58" cy="62" r="2.3" fill="var(--nochebuena)" stroke="var(--paper)" strokeWidth="0.6" />
            <circle cx="67" cy="73" r="2.3" fill="var(--oro-fiesta)" />
            <circle cx="52" cy="75" r="2.3" fill="var(--nochebuena)" stroke="var(--paper)" strokeWidth="0.6" />
            <circle cx="62" cy="52" r="1.8" fill="var(--oro-fiesta)" />
        </PostalStamp>
    );
}
